import React from 'react';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';

// TODO: is it need to have a preference for dymamic icon color?
const StarIcon = ({ starIndex, rate }) => {
	// Return empty star if rating < givenRating
	if (Math.ceil(rate) < starIndex) {
		return (
			<i
				className="ddc-icon ddc-icon-star-empty"
				style={{ color: '#F3BC2A' }}
			/>
		);
	}

	const isHalfStarRender = starIndex % rate < 1;
	if (isHalfStarRender) {
		return (
			<i
				className="ddc-icon ddc-icon-star-half"
				style={{ color: '#F3BC2A' }}
			/>
		);
	}

	return (
		<i
			className="ddc-icon ddc-icon-star-full"
			style={{ color: '#F3BC2A' }}
		/>
	);
};

const StarRating = ({ rating, ratingScale }) => {
	return (
		<div className="star-ratings ml-3" aria-hidden="true">
			{[...Array(ratingScale)].map((_item, index) => {
				const givenRating = index + 1;
				return (
					<StarIcon
						starIndex={givenRating}
						rate={rating}
						key={uuidv4()}
					/>
				);
			})}
		</div>
	);
};

StarIcon.propTypes = {
	starIndex: PropTypes.number.isRequired,
	rate: PropTypes.number.isRequired
};

StarRating.propTypes = {
	rating: PropTypes.number.isRequired,
	ratingScale: PropTypes.number.isRequired
};

export default StarRating;
